import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const PlatformProof = () => {
  const { t } = useLanguage();
  const mcpContent = t('screenshots.items')?.[0];
  const mcpFeatures = Array.isArray(mcpContent?.features) ? mcpContent.features : [];

  return (
    <section id="mcp" className="relative scroll-mt-28 overflow-hidden bg-[#050507] py-24 text-[#fffefa] sm:py-28">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
      <div className="absolute -left-28 top-28 h-96 w-96 rounded-full bg-[#7f49f5]/15 blur-3xl" />
      <div className="absolute -right-28 bottom-16 h-80 w-80 rounded-full bg-[#0a84ae]/10 blur-3xl" />

      <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
          <div>
            <div className="text-xs font-medium uppercase tracking-[0.16em] text-[#0a84ae]">
              {mcpContent?.title || 'ChatGPT + FARM MCP'}
            </div>
            <h2 className="mt-5 text-4xl font-normal leading-tight text-white sm:text-5xl lg:text-[56px]">
              {t('platform.subtitle')}
            </h2>
            <p className="mt-6 max-w-xl text-lg leading-8 text-[#b7b5c2]">
              {t('platform.description')}
            </p>

            <div className="mt-10 divide-y divide-white/10 border-y border-white/10">
              {mcpFeatures.map((feature, index) => (
                <div key={feature} className="grid grid-cols-[32px_1fr] gap-4 py-4">
                  <span className="pt-0.5 text-xs text-white/30">0{index + 1}</span>
                  <span className="text-[#d7d6de]">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-[500px]">
            <div className="absolute inset-x-10 top-16 h-96 rounded-full bg-[#7f49f5]/25 blur-3xl" />
            <div className="relative overflow-hidden rounded-[28px] border border-white/10 bg-black p-2 shadow-[0_36px_110px_rgba(0,0,0,0.68)]">
              <img
                src="/farm-mcp-workflow.png"
                alt="ChatGPT and FARM MCP transaction proposal workflow"
                className="block h-auto w-full rounded-[22px]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformProof;
